<template>
  <div class='nav__header' data-qa="header-div-rwfcdc">
    <v-main data-qa="header-main-ch5gf">
      <v-app-bar app class='mx-auto overflow-hidden bg-white' color="#FFFFFF" data-qa="header-app-bar-mk1uif">
        <v-icon v-if='showDrawerButton' @click='toggleDrawer()' :color='primaryColor' data-qa="header-icon-0avkvz">{{ this.displayLogo ? 'mdi-menu' : 'mdi-chevron-left' }}</v-icon>
        <div v-if='displayLogo' class='nav__header-logo hidden-sm-and-down ml-4' data-qa="header-div-k3gj9b"></div>
        <Breadcrumb v-if="$appSettings.headerConfig.breadcrumb" />
        <v-spacer data-qa="header-spacer-phy846"></v-spacer>
        <div v-if="$appSettings.headerConfig.fullscreen" class="hidden-sm-and-down" data-qa="header-div-b6omsj">
        <v-tooltip data-qa="header-tooltip-3irz4">
          <template v-slot:activator='{ on }'>
            <div v-on='on' data-qa="header-div-xpbrkh">
              <v-btn icon data-qa="header-btn-u221hd">
                <v-icon @click='handleFullScreen()' :color='onSurfaceMedium' class="material-symbols-outlined" data-qa="header-icon-002ro">
                  fullscreen</v-icon>
              </v-btn>
            </div>
          </template>
          <span data-qa="header-span-giyqwr">{{ $t('header.tooltip_fullScreen') }}</span>
        </v-tooltip>
        </div>
        <!-- <div class="hidden-sm-and-down" data-qa="header-div-ebnyt">
        <GlobalSearch v-if="$appSettings.headerConfig.searchComponent" />
        </div> -->
        <div v-if="$appSettings.headerConfig.helpComponent" class="hidden-sm-and-down" data-qa="header-div-uleg3n">
        <v-btn
          icon
          target='_blank'
          name='help-url'
          class="ma-2"
          :href='$appSettings.applicationSettings.helpUrl'
          :color='onSurfaceMedium' data-qa="header-btn-x0maze">
          <v-icon class="material-symbols-outlined" data-qa="header-icon-6a8s8a">help</v-icon>
        </v-btn>
        </div>
        <div class="hidden-sm-and-down" data-qa="header-div-2chqk">
        <NotificationList v-if="$appSettings.headerConfig.notificationComponent" />
        </div>
        <div class="hidden-sm-and-down" data-qa="header-div-cg0ry">
        <UserProfile v-if="$appSettings.headerConfig.profileComponent" />
        </div>
        <div class="hidden-sm-and-down" data-qa="header-div-9ipb5b">
        <v-btn icon v-if="!$appSettings.headerConfig.profileComponent" text v-show='headerLogoutIcon && headerConfig.showLogoutButton' data-qa="header-btn-tmq3ib">
          <v-icon
            class="ma-2 material-symbols-outlined"
            @click='logoutConfirm'
            :color='primaryColor'
             data-qa="header-icon-oa5yy">move_item</v-icon
          >
        </v-btn>
        </div>
        <div v-if="$vuetify.breakpoint.mobile" data-qa="header-div-4helr">
          <v-menu bottom left data-qa="header-menu-jeujf">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="material-symbols-outlined" data-qa="header-btn-3559h">
              <v-icon data-qa="header-icon-fcoumh">more_vert</v-icon>
            </v-btn>
          </template>
          <v-list data-qa="header-list-743wyg">
            <!-- <v-list-item data-qa="header-list-item-w9daya">
              <GlobalSearch v-if="$appSettings.headerConfig.searchComponent" />
            </v-list-item> -->
            <v-list-item v-if="$appSettings.headerConfig.helpComponent" data-qa="header-list-item-ie8g5">
              <v-btn
                icon
                target='_blank'
                name='help-url'
                class="ma-2"
                :href='$appSettings.applicationSettings.helpUrl'
                :color='primaryColor' data-qa="header-btn-sy4egl">
                <v-icon class="material-symbols-outlined" data-qa="header-icon-4hkzw">help</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item data-qa="header-list-item-y9sbtf">
              <NotificationList v-if="$appSettings.headerConfig.notificationComponent" />
            </v-list-item>
            <v-list-item data-qa="header-list-item-lycvyry">
              <UserProfile v-if="$appSettings.headerConfig.profileComponent" />
              <v-btn icon v-if="!$appSettings.headerConfig.profileComponent" text v-show='headerLogoutIcon && headerConfig.showLogoutButton' data-qa="header-btn-3df1e8">
              <v-icon
                class="ma-2 material-symbols-outlined"
                @click='logoutConfirm'
                :color='primaryColor'
                 data-qa="header-icon-stc">move_item</v-icon
              >
            </v-btn>
            </v-list-item>
          </v-list>
          </v-menu>
        </div>
      </v-app-bar>
      <Modal v-if="!$appSettings.headerConfig.profileComponent" :config='modalConfig' @btn1Action='logout' />
    </v-main>
  </div>
</template>
<script>
import UserProfile from '@/components/common/UserProfile.vue'
import Breadcrumb from '@/components/common/Breadcrumb'
// TODO import GlobalSearch from '@/components/common/GlobalSearch'
import NotificationList from '@/components/common/NotificationList'
import '@/styles/common/appbar.scss'
import event from '@/util/event'
import preload from '@/util/preload'
import store from '@/core/store'
import { loadLanguage } from '@/plugins/vueI18n'

export default {
  name: 'Header',
  props: {
    headerConfig: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    UserProfile,
    // TODO GlobalSearch,
    Breadcrumb,
    NotificationList
  },
  beforeCreate () {
    const partyPreferredLanguage = store.getters['profileStore/profileData'].preferredLanguage
    const defaultLocalizationKey = this.$appSettings.localizationAndLanguageSettings.defaultLocalizationKey
    if (partyPreferredLanguage && partyPreferredLanguage.length && partyPreferredLanguage !== defaultLocalizationKey) {
      this.$i18n.locale = partyPreferredLanguage
      loadLanguage(this.$i18n.locale)
    } else {
      if (this.$route.params.from !== 'login') {
        this.$i18n.locale = defaultLocalizationKey
        loadLanguage(this.$i18n.locale)
      }
    }
  },
  created () {
    event.$on('Hide_header_logo', () => {
      this.displayLogo = !this.displayLogo
      this.headerLogoutIcon = !this.headerLogoutIcon
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  data () {
    return {
      // TODO: This will be picked up later
      // showAddButton: this.headerConfig.showAddButton || false,
      displayLogo: false,
      headerLogoutIcon: true,
      isLogout: false,
      modalConfig: {
        btn2Label: this.$t('common.no'),
        enabled: false,
        persistent: true,
        subtitle: this.$t('common.confirmation_message'),
        btn1Label: this.$t('common.yes'),
        outlinedSaveBtn: false,
        title: this.$t('common.logoutText'),
        width: 400
      },
      showDrawerButton: this.headerConfig.showDrawerButton || false
    }
  },
  mounted () {
    this.checkToken()
  },
  methods: {
    checkToken () {
      let timerInterval = ''
      if (!this.isLogout && this.$appSettings.authConfigurations.enableB2C) {
        // converting expireTimeFormat (seconds) to IntervalTimeFormat (milliseconds)
        const refreshInterval = (120 * 1000) // TODO - Static to 3 min refresh interval
        const userSession = sessionStorage.getItem('userSession')
        timerInterval = setInterval(() => {
          if (!this.isLogout && userSession) {
            preload.refreshToken(refreshInterval, false)
          }
        }, refreshInterval)
      } else clearInterval(timerInterval)
    },
    toggleDrawer () {
      event.$emit('APP_DRAWER_TOGGLED', true)
    },
    handleFullScreen () {
      const doc = window.document
      const docEl = doc.documentElement
      const requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen
      const cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen
      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl)
      } else {
        cancelFullScreen.call(doc)
      }
    },
    logout () {
      sessionStorage.clear()
      this.$router.push('/login')
    },
    logoutConfirm () {
      this.modalConfig.enabled = true
    },
    showDialog () {
      this.drawer = false
      return (this.dialog = true)
    }
  }
}
</script>
<style scoped>
.logoutButton {
  position: absolute;
  width: 90%;
  bottom: 15px;
  right: 5%;
  text-align: center;
}
</style>
